import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

class UxDropdownComponent {
    constructor() {
        this._isActive = false;
        this._isRightAligned = true;
        this.width = '10rem';
        this.height = 'auto';
        this.e2eAttr = 'ux-dropdown';
        this.clickedOutside = new EventEmitter();
    }
    get isActive() { return this._isActive; }
    set isActive(value) { this._isActive = coerceBooleanProperty(value); }
    get isRightAligned() { return this._isRightAligned; }
    set isRightAligned(value) { this._isRightAligned = coerceBooleanProperty(value); }
    closeDropDownOnEscape(keyCode) {
        // 27 = escape
        // eslint-disable-next-line import/no-deprecated
        if (keyCode.keyCode === 27) {
            this.isActive = false;
        }
    }
}
/** @nocollapse */ UxDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ UxDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: UxDropdownComponent, selector: "ux-dropdown", inputs: { styleClass: "styleClass", isActive: "isActive", isRightAligned: "isRightAligned", width: "width", height: "height", e2eAttr: "e2eAttr" }, outputs: { clickedOutside: "clickedOutside" }, ngImport: i0, template: `
        <div class="ux-dropdown ux-dropdown-menu" [style.min-width]="width" [style.max-height]="height"
             [class.d-block]="isActive"
             [class.ux-dropdown-menu-right]="isRightAligned"
             (keydown)="closeDropDownOnEscape($event)"
             attr.data-e2e="{{ e2eAttr }}">
            <ng-content></ng-content>
        </div>
    `, isInline: true, styles: [".ux-dropdown{height:auto;margin-top:0;max-height:300px;overflow-x:hidden;padding:var(--eui-base-spacing-m);box-shadow:var(--eui-base-shadow-2)}.ux-dropdown.ux-dropdown-menu{z-index:var(--eui-base-z-index-menu)}.ux-dropdown.ux-dropdown-menu-right{left:auto;right:0}.ux-dropdown.ux-dropdown-menu-left{left:0;right:auto}.dropdown-toggle,.ux-dropdown-toggle{white-space:nowrap}.dropdown-toggle:after,.ux-dropdown-toggle:after{height:1rem;width:1rem;content:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Down%3C/title%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 184l144 144 144-144'/%3E%3C/svg%3E\");display:inline-block;margin-left:var(--eui-base-spacing-xs);vertical-align:middle}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ux-dropdown', template: `
        <div class="ux-dropdown ux-dropdown-menu" [style.min-width]="width" [style.max-height]="height"
             [class.d-block]="isActive"
             [class.ux-dropdown-menu-right]="isRightAligned"
             (keydown)="closeDropDownOnEscape($event)"
             attr.data-e2e="{{ e2eAttr }}">
            <ng-content></ng-content>
        </div>
    `, encapsulation: ViewEncapsulation.None, styles: [".ux-dropdown{height:auto;margin-top:0;max-height:300px;overflow-x:hidden;padding:var(--eui-base-spacing-m);box-shadow:var(--eui-base-shadow-2)}.ux-dropdown.ux-dropdown-menu{z-index:var(--eui-base-z-index-menu)}.ux-dropdown.ux-dropdown-menu-right{left:auto;right:0}.ux-dropdown.ux-dropdown-menu-left{left:0;right:auto}.dropdown-toggle,.ux-dropdown-toggle{white-space:nowrap}.dropdown-toggle:after,.ux-dropdown-toggle:after{height:1rem;width:1rem;content:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Down%3C/title%3E%3Cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 184l144 144 144-144'/%3E%3C/svg%3E\");display:inline-block;margin-left:var(--eui-base-spacing-xs);vertical-align:middle}\n"] }]
        }], propDecorators: { styleClass: [{
                type: Input
            }], isActive: [{
                type: Input
            }], isRightAligned: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], clickedOutside: [{
                type: Output
            }] } });
class UxDropdownComponentModule {
}
/** @nocollapse */ UxDropdownComponentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ UxDropdownComponentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponentModule, declarations: [UxDropdownComponent], imports: [CommonModule], exports: [UxDropdownComponent] });
/** @nocollapse */ UxDropdownComponentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponentModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: UxDropdownComponentModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    exports: [UxDropdownComponent],
                    declarations: [UxDropdownComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { UxDropdownComponent, UxDropdownComponentModule };
